import React from 'react';
import { useAnnouncementContext } from 'Context/AnnouncementContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import DataContainer from 'Components/UI/DataContainer';
import { FDDialog } from '@facet-wealth/design';
import DialogContent from './DialogContent';

const AnnouncementDialog = () => {
  const {
    initializingError,
    modal: {
      isDialogOpen,
      currentStepResource,
      markAsDismissed,
      isDismissible,
    },
  } = useAnnouncementContext();

  const isMobile = useMobileLayout();

  return (
    <FDDialog
      onClose={markAsDismissed}
      fullScreen={isMobile}
      open={isDialogOpen}
      noCloseButton
      dialogWidth={'md'}
      closeOnBackdropClick={isDismissible}
    >
      <DataContainer
        loading={!currentStepResource}
        loadingError={initializingError}
        component={DialogContent}
      />
    </FDDialog>
  );
};

export default AnnouncementDialog;
